const capitlizeText = (str?: string) => {
  return (
    str
      ?.replaceAll("_", " ")
      ?.toLowerCase()
      ?.split(" ")
      ?.map((item) => {
        if (!item) return "";
        const [first, ...rest] = item || "";
        return `${first.toUpperCase()}${rest.join("")}`;
      })
      .join(" ") || ""
  );
};
export default capitlizeText;
